import React, { useState, useEffect } from "react";
import {
  Container,
  Collapse,
  NavbarToggler,
  NavItem,
  Dropdown,
  DropdownToggle,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import classname from "classnames";
import Avatar from "../../../assets/images/avatar.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../actions/customer";
import EmployerUserDropdown from "./EmployerUserDropdown";
import CandidateUserDropdown from "./CandidateUserDropdown";
import WebsiteLogo from "../../../helpers/WebsiteLogo";
import {
  authKey_local_storage_key,
  dataUrl,
  isUserEmployer,
} from "../../../helpers/common";
import Notification from "../Notification";
import { Icon } from "@iconify/react";
import { GET_JOBS_APPLICATIONS_FAILURE } from "../../../constants/actionTypes";
import profileImage from "../../../assets/images/avatar.png";
import UsersWallet from "./UsersWallet";
// import Notification from "./Notification";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { profile } = useSelector((state) => state.customer);
  const navigate = useNavigate();
  const location = useLocation();
  const authToken = localStorage.getItem(authKey_local_storage_key);
  const dispatch = useDispatch();

  // 🎯 FIX: Initialize directly from localStorage instead of null.
  // This makes it correct even on a fresh mount (e.g. after navigating
  // away and back), not only while the listener happens to be live.
  const [instantImage, setInstantImage] = useState(
    () => localStorage.getItem("temp_uploaded_avatar_url") || null,
  );

  useEffect(() => {
    const handleInstantRefresh = () => {
      const cachedUrl = localStorage.getItem("temp_uploaded_avatar_url");
      if (cachedUrl) {
        setInstantImage(cachedUrl);
      }
    };

    window.addEventListener("instant_navbar_refresh", handleInstantRefresh);
    return () => {
      window.removeEventListener(
        "instant_navbar_refresh",
        handleInstantRefresh,
      );
    };
  }, []);

  // ✅ safe additional_fields parsing
  const additional_fields = profile?.additional_fields
    ? typeof profile.additional_fields === "string"
      ? JSON.parse(profile.additional_fields)
      : profile.additional_fields
    : {};

  const profile_picture = additional_fields?.profile_picture
    ? `https://sdsjobseekers.runasp.net/uploads/profile_image/${additional_fields.profile_picture}`
    : "";

  const userId = profile?.id || profile?.userId;

  const userName =
    profile?.fullName || profile?.username || profile?.name || "";

  // ✅ ROLE FIX: role ek hi jagah se tay hota hai, menu / dropdown / badge teeno yahi use karte hain
  const toType = (v) =>
    v === undefined || v === null || v === "" ? null : Number(v);

  const typeTop = toType(profile?.customerType);
  const typeData = toType(profile?.data?.customerType);

  const isEmployer =
    profile?.role === "employer" ||
    profile?.data?.role === "employer" ||
    typeTop === 1 ||
    typeData === 1;

  const isCandidate = !isEmployer && (typeTop === 0 || typeData === 0);

  // token hai par role abhi pata nahi chala (refresh ke beech ka waqt)
  const roleLoading = Boolean(authToken) && !isEmployer && !isCandidate;

  const [userProfile, setUserProfile] = useState(false);

  const toggleUserDropdown = () => {
    if (authToken) {
      setUserProfile((prevState) => !prevState);
    }
  };

  const onLogout = () => {
    dispatch(logout());
    dispatch({ type: GET_JOBS_APPLICATIONS_FAILURE });
    setUserProfile(false);

    // 🎯 NEW: Clear the cached avatar on logout so the next user
    // (or a logged-out state) doesn't briefly show someone else's photo.
    localStorage.removeItem("temp_uploaded_avatar_url");
    setInstantImage(null);
  };

  const goToSignin = () => {
    if (!authToken) {
      navigate("/signin");
    }
  };

  const menusData = useSelector((state) => state.menus.data);
  const menus = Array.isArray(menusData) ? menusData : menusData?.data || [];

  // ✅ ROLE FIX: menu category ab isEmployer se aati hai
  const menuCategory = !userId
    ? "top_menus"
    : isEmployer
      ? "top_employers_menus"
      : "top_employee_menus";

  const topMenus = menus.filter((menu) => menu.category === menuCategory);
  const parentMenus = topMenus.filter((menu) => menu.parentId === 0);

  const [navClass, setNavClass] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  // 🎯 FIX: removed reference to undefined `profileImage`.
  // Priority: instant cache > Redux profileImage > additional_fields > default avatar.
  const finalImage =
    instantImage ||
    (profile?.data?.profileImage
      ? profile.data.profileImage.startsWith("http")
        ? profile.data.profileImage
        : `https://sdsjobseekers.runasp.net/uploads/profile_image/${profile.data.profileImage}`
      : profile_picture || Avatar);

  useEffect(() => {
    function scrollNavigation() {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setNavClass("nav-sticky");
      } else {
        setNavClass("");
      }

      setLastScrollY(currentScrollY);
    }

    window.addEventListener("scroll", scrollNavigation, true);

    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
    };
  }, [lastScrollY]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navbarCollapse");
    if (ul) {
      var items = ul.getElementsByTagName("a");
      removeActivation(items);
      for (var i = 0; i < items.length; ++i) {
        if (location.pathname === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    }
  });

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement.parentElement.parentElement;

    if (parent) {
      parent.classList.add("active");
      const parent2 = parent.parentElement;
      parent2.classList.add("active");
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active");
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active");
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active");
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active");
            }
          }
        }
      }
    }
    return false;
  }

  const getChildMenus = (id) => {
    return topMenus.filter((menu) => menu.parentId === id);
  };

  const scrollTop = () => {
    return window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <React.Fragment>
      <nav
        className={"navbar navbar-expand-lg fixed-top sticky p-0 " + navClass}
      >
        <Container fluid className="custom-container">
          <Link
            className="navbar-brand text-dark fw-bold me-auto"
            to={isUserEmployer(profile) ? "/candidates" : "/"}
          >
            <WebsiteLogo height="70" />
          </Link>

          <NavbarToggler className="me-3" onClick={toggle}>
            {isOpen ? (
              <i className="mdi mdi-close"></i>
            ) : (
              <i className="mdi mdi-menu"></i>
            )}
          </NavbarToggler>

          <Collapse isOpen={isOpen} className="navbar-collapse">
            <ul className="navbar-nav mx-auto navbar-center align-items-center">
              {parentMenus?.map((menu) => {
                // Check if current route matches menu URL
                const isActive = location.pathname === menu.url;

                return (
                  <NavItem key={menu.id} className="dropdown dropdown-hover">
                    <Link
                      to={getChildMenus(menu.id)?.length > 0 ? "#" : menu.url}
                      className={`nav-link fw-medium ${isActive ? "active text-primary fw-bold" : ""
                        }`}
                      onClick={() => {
                        scrollTop();
                        setIsOpen(false);
                      }}
                    >
                      {menu.name}
                    </Link>
                  </NavItem>
                );
              })}
            </ul>
          </Collapse>

          <ul className="header-menu list-inline d-flex align-items-center mb-0">
            <li>{userId && <Notification />}</li>

            <UsersWallet />

            <Dropdown
              isOpen={userProfile}
              toggle={toggleUserDropdown}
              className="list-inline-item"
              onClick={goToSignin}
            >
              <DropdownToggle
                className="header-item d-flex align-items-center gap-2"
                tag="a"
              >
                {userId ? (
                  <img
                    src={finalImage}
                    alt="profile pic"
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                      marginTop: "15px",
                    }}
                    className="avatar-lg img-thumbnail rounded-circle mb-4"
                  />
                ) : (
                  <Icon
                    icon="solar:login-3-bold-duotone"
                    fontSize={22}
                    className="text-primary"
                  />
                )}

                {/* Hide text on mobile, show from md and above */}
                <div className="d-none d-md-flex flex-column">
                  <div
                    className="d-flex flex-column"
                    style={{ cursor: "pointer", lineHeight: "1.2" }}
                  >
                    <span className="fw-semibold text-dark">
                      {profile?.name ||
                        profile?.data?.name ||
                        additional_fields?.name ||
                        ""}
                    </span>

                    {profile?.email ||
                      profile?.data?.email ||
                      additional_fields?.email ? (
                      <small className="text-muted">
                        {profile?.email ||
                          profile?.data?.email ||
                          additional_fields?.email}
                      </small>
                    ) : (
                      <small className="fw-bold">Sign in to continue</small>
                    )}
                  </div>

                  {/* ✅ ROLE FIX: badge ab isEmployer / isCandidate se dikhta hai */}
                  {userId && (isEmployer || isCandidate) && (
                    <div className="mt-1">
                      <span
                        className={`badge rounded-pill px-3 py-1 fw-semibold fs-12 ${isEmployer
                          ? "bg-primary-subtle text-primary border border-primary-subtle"
                          : "bg-primary-subtle text-primary border border-info-subtle"
                          }`}
                      >
                        <i
                          className={`mdi ${isEmployer ? "mdi-domain me-1" : "mdi-account me-1"
                            }`}
                        ></i>
                        {isEmployer ? "Employer" : "Candidate"}
                      </span>
                    </div>
                  )}
                </div>
              </DropdownToggle>

              {/* ✅ ROLE FIX: role pata chalne tak koi dropdown nahi, phir sahi wala */}
              {!roleLoading &&
                (isEmployer ? (
                  <EmployerUserDropdown
                    onLogout={onLogout}
                    toggleUserDropdown={toggleUserDropdown}
                  />
                ) : (
                  <CandidateUserDropdown
                    onLogout={onLogout}
                    toggleUserDropdown={toggleUserDropdown}
                  />
                ))}
            </Dropdown>

            {!userId && (
              <>
                <div className="d-none d-md-flex flex-column flex-md-row align-items-center gap-2">
                  <button
                    className="btn btn-outline register-btn d-flex flex-column align-items-center justify-content-center w-100 w-md-auto mb-2 mb-md-0"
                    onClick={() => navigate("/signup?role=0")}
                  >
                    <span className="btn-sub-text">Register</span>
                    <span className="btn-main-text">Candidate</span>
                  </button>

                  <button
                    className="btn btn-outline register-btn d-flex flex-column align-items-center justify-content-center w-100 w-md-auto"
                    onClick={() => navigate("/signup?role=1")}
                  >
                    <span className="btn-sub-text">Register</span>
                    <span className="btn-main-text">Employer</span>
                  </button>
                </div>
              </>
            )}
          </ul>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default NavBar;